"use strict";

var Logger = require("js-logger");

Logger.useDefaults({
	defaultLevel: Logger.ERROR
});

module.exports = {
	BootstrapPrompt: require("../shared/BootstrapPrompt"),
	CarouselActions: require("../actions/CarouselActions"),
	CategoryActions: require("../actions/CategoryActions"),
	CategoryDropdown: require("./CategoryDropdown"),
	CategoryPaging: require("./CategoryPaging"),
	DonationFrequency: require("../projectComponents/DonationFrequency"),
	EmailSubscriptionActions: require("../actions/EmailSubscriptionActions"),
	EmailSubscriptionStore: require("../stores/EmailSubscriptionStore"),
	ExpanderActions: require("../actions/ExpanderActions"),
	GiveAnonymousCheckbox: require("../projectComponents/GiveAnonymousCheckbox"), // Included here because it has dependencies on these
	HtmlHelper: require("../shared/HtmlHelper"),
	LogoutActions: require("../actions/LogoutActions"),
	NavigationActions: require("../actions/NavigationActions"),
	Paging: require("./Paging"),
	PledgeActions: require("../actions/PledgeActions"),
	PledgeFrequency: require("../pledgeComponents/PledgeFrequency"),
	PledgeGiftArray: require("../pledgeComponents/PledgeGiftArray"),
	PostalCodeHelper: require("../accountComponents/PostalCodeHelper"),
	ProductActions: require("../actions/ProductActions"),
	ProductVariantsHelper: require("../productComponents/ProductVariantsHelper"),
	ProjectActions: require("../projectComponents/ProjectActions"),
	ProjectGiftArray: require("../projectComponents/ProjectGiftArray"),
	ProjectStore: require("../projectComponents/ProjectStore"),
	Quantity: require("../productComponents/Quantity"),
	QueryStringHelper: require("../shared/QueryStringHelper"),
	RecurringUpsellCheckbox: require("../projectComponents/RecurringUpsellCheckbox"),
	SearchSorting: require("../searchComponents/SearchSorting"),
	ShipToActions: require("../actions/ShipToActions"),
	SlideShowActions: require("../actions/SlideShowActions"),
	SubaccountGiftArray: require("../projectComponents/SubaccountGiftArray"), // Included here because it has dependencies on these
	TabActions: require("../actions/TabActions"),
	TokenStore: require("../client/TokenStore"),
	UseOnDaySelector: require("../projectComponents/UseOnDaySelector"),
	VisibilityStore: require("../client/VisibilityStore")
};
